import React, { useEffect, useMemo, useState } from "react";
import dayjs from "dayjs";

import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import "dayjs/locale/pt-br";

import { NumericFormat } from "react-number-format";
import {
  Checkbox,
  IconButton,
  MenuItem,
  Select,
  TextField,
  Tooltip,
} from "@mui/material";

import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import ArchiveIcon from "@mui/icons-material/Archive";
import ModeCommentIcon from "@mui/icons-material/ModeComment";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import AbcIcon from "@mui/icons-material/Abc";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { Article } from "@mui/icons-material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import LastPageIcon from "@mui/icons-material/LastPage";

import { CreateNewOportunityModal } from "../OportunityModal";

import {
  AddingSection,
  CardsSection,
  FiltersSection,
  Form,
  HighlightSpan,
  IconContainer,
  InputContainer,
  InputContainerCargo,
  InputContainerDate,
  InputContainerHalf,
  InputRow,
  InputRowSubmit,
  LeftSection,
  OportunityCard,
  OportunityContainer,
  SubmitButton,
  ToggleViewButton,
  WarningInputMessage,
} from "./styled";
import { toast } from "react-toastify";
import api from "../../api/axios";
import { Checkboxes } from "../Checkboxes";
import { ProfessionalDocsModal } from "../ProfessionalDocsModal";
import { TriagemOccurencesModal } from "../TriagemOccurrencesModal";
import { useNavigate } from "react-router-dom";

const REGIMES = ["Presencial", "Remoto", "Híbrido"];
const STATUS_TYPES = ["ativa", "inativa", "arquivada"];
const APPLICATION_STATUS_TYPES = [
  "Triagem",
  "Reunião Inicial",
  "Reunião Técnica",
  "Classificado",
  "Não Classificado",
  "Aprovado",
  "Não Aprovado",
];

export const OportunityTable = ({ tableData, getData }) => {
  const navigate = useNavigate();

  const [modalOpen, setModalOpen] = useState(false);

  const [application, setApplication] = useState({});

  const [oportunity, setOportunity] = useState({
    cargo: "",
    local: "",
    remuneracao: null,
    empresa: "",
    vinculo: "",
    regime: "",
    descricao: "",
    status: "",
    inicio_vigencia: null,
    fim_vigencia: null,
    skills: [],
  });

  const [searchValue, setSearchValue] = useState("");
  const [sortDirection, setSortDirection] = useState("cresc");
  const [sortType, setSortType] = useState("cargo");

  const [originalData, setOriginalData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);

  const [currentOportunityPage, setCurrentOportunityPage] = useState(1);
  const [itemsPerOportunityPage, setItemsPerOportunityPage] = useState(5);

  const [currentApplicationPage, setCurrentApplicationPage] = useState(1);
  const [itemsPerApplicationsPage, setItemsPerApplicationsPage] = useState(10);

  const [startAppIndex, setStartAppIndex] = useState(null);
  const [endAppIndex, setEndAppIndex] = useState(null);
  const [paginatedApplications, setPaginatedApplications] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [totalAppPages, setTotalAppPages] = useState(null);

  const [appStatusCount, setAppStatusCount] = useState({});

  const [skills, setSkills] = useState([]);

  const [allOccurrences, setAllOccurrences] = useState([]);

  const [filters, setFilters] = useState({
    status: "Todos",
    modalidade: "Todos",
    skill: "Todos",
    vigenciaField: "inicio_vigencia",
    vigenciaStart: null,
    vigenciaEnd: null,
  });
  const [applicationFilters, setApplicationFilters] = useState({
    status: "Todos",
  });

  const [isAdding, setIsAdding] = useState(false);
  const [operationType, setOperationType] = useState(null);

  const [isShowingApplications, setIsShowingApplications] = useState(false);
  const [applications, setApplications] = useState([]);
  const [filteredApplications, setFilteredApplications] = useState([]);

  const [selectedApplications, setSelectedApplications] = useState([]);

  const [selectedProfessional, setSelectedProfessional] = useState(null);
  const [professionalDocsModalOpen, setProfessionalDocsModalOpen] =
    useState(false);

  const [triagemOccurrencesModalOpen, setTriagemOccurrencesModalOpen] =
    useState(false);

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [error, setError] = useState("");

  const resetValues = () => {
    setOportunity({
      cargo: "",
      local: "",
      remuneracao: null,
      empresa: "",
      vinculo: "",
      regime: "",
      descricao: "",
      status: "",
      inicio_vigencia: null,
      fim_vigencia: null,
      skills: [],
    });

    setApplication({});
  };

  const getSkills = async () => {
    try {
      const res = await api.get("/skill/list");

      const sortedSkills = [...res.data].sort((a, b) =>
        a.name.localeCompare(b.name, "pt-BR", { sensitivity: "base" }),
      );

      setSkills(sortedSkills);
    } catch (error) {
      console.error(error);
      toast.error("Erro ao carregar as habilidades");
    }
  };

  const toggleView = (state) => {
    setIsAdding(state);
    resetValues();
    setOperationType(!state ? null : "create");
  };

  const openModal = (item) => {
    setOportunity(item);
    setModalOpen(true);
  };

  const closeModal = () => {
    resetValues();
    setModalOpen(false);
  };

  const handleViewProfessional = (application) => {
    const professionalIds = filteredApplications.map(
      (appItem) => appItem.professional?.user,
    );

    sessionStorage.setItem(
      "adminPageState",
      JSON.stringify({
        selectedTable: "oportunity",
        selectedOportunity: application.oportunity?._id,
        selectedProfessionalId: application.professional?._id,
        currentApplicationPage: currentApplicationPage,
        professionalIds,
        applicationFiltersStatus: applicationFilters.status,
      }),
    );

    navigate(`/editar-profissional/${application.professional?.user}`);
  };

  const handleSubmit = async () => {
    try {
      setIsSubmitting(true);
      setError("");

      if (!oportunity.status) delete oportunity.status;

      const isFormValid = Object.entries(oportunity).every(([key, value]) => {
        if (key === "fim_vigencia" || key === "remuneracao" || key === "local")
          return true;
        return value !== "" && value !== null;
      });

      if (!isFormValid) {
        setError("Preencha todos os campos");
        setIsSubmitting(false);
        return;
      }

      if (oportunity.fim_vigencia) {
        const inicio = new Date(oportunity.inicio_vigencia);
        const fim = new Date(oportunity.fim_vigencia);

        if (isNaN(inicio.getTime()) || isNaN(fim.getTime())) {
          setError("Datas inválidas");
          setIsSubmitting(false);
          return;
        }

        if (fim <= inicio) {
          setError("A data final deve ser maior que a data inicial");
          setIsSubmitting(false);
          return;
        }
      }

      const res = await api.post("/oportunity/create", oportunity);

      if (res.status === 200) {
        toast.success("Oportunidade criada com sucesso!");
      }

      resetValues();
      setIsAdding(false);
      setIsSubmitting(false);
      setOperationType(null);
      getData("oportunity");
    } catch (err) {
      setIsSubmitting(false);
      toast.error("Ocorreu um erro: ", err);
      console.log(err);
    }
  };

  const handleEditSave = async () => {
    try {
      setIsSubmitting(true);
      setError("");

      const isFormValid = Object.entries(oportunity).every(([key, value]) => {
        if (key === "fim_vigencia" || key === "remuneracao") return true;
        return value !== "" && value !== null;
      });

      if (!isFormValid) {
        setError("Preencha todos os campos");
        setIsSubmitting(false);
        return;
      }

      if (oportunity.fim_vigencia) {
        const inicio = new Date(oportunity.inicio_vigencia);
        const fim = new Date(oportunity.fim_vigencia);

        if (isNaN(inicio.getTime()) || isNaN(fim.getTime())) {
          setError("Datas inválidas");
          setIsSubmitting(false);
          return;
        }

        if (fim <= inicio) {
          setError("A data final deve ser maior que a data inicial");
          setIsSubmitting(false);
          return;
        }
      }

      const res = await api.put(
        `/oportunity/update/${oportunity._id}`,
        oportunity,
      );

      if (res.status === 200) {
        toast.success("Oportunidade atualizada com sucesso!");
      }

      resetValues();
      setIsAdding(false);
      setIsSubmitting(false);
      setOperationType(null);
      getData("oportunity");
    } catch (err) {
      setIsSubmitting(false);
      toast.error("Ocorreu um erro: ", err);
      console.log(err);
    }
  };

  const handleDelete = async () => {
    try {
      setIsSubmitting(true);

      const res = await api.delete(`/oportunity/delete/${oportunity._id}`);

      if (res.status === 200) {
        toast.success("Oportunidade removida com sucesso!");
      }

      resetValues();
      setIsAdding(false);
      setIsSubmitting(false);
      setOperationType(null);
      getData("oportunity");
    } catch (err) {
      setIsSubmitting(false);
      toast.error("Ocorreu um erro: ", err);
      console.log(err);
    }
  };

  const handleArchive = async () => {
    try {
      setIsSubmitting(true);

      const res = await api.put(`/oportunity/archive/${oportunity._id}`);

      if (res.status === 200) {
        toast.success("Oportunidade arquivada com sucesso!");
      }

      resetValues();
      setIsAdding(false);
      setIsSubmitting(false);
      setOperationType(null);
      getData("oportunity");
    } catch (err) {
      setIsSubmitting(false);
      toast.error("Ocorreu um erro: ", err);
      console.log(err);
    }
  };

  const lastOccurrencesByOportunity = useMemo(() => {
    const occurrencesMap = {};

    allOccurrences.forEach((occurrence) => {
      const oportunityId =
        typeof occurrence.oportunity === "object"
          ? occurrence.oportunity?._id
          : occurrence.oportunity;

      if (!oportunityId) return;

      if (
        !occurrencesMap[oportunityId] ||
        new Date(occurrence.date) > new Date(occurrencesMap[oportunityId].date)
      ) {
        occurrencesMap[oportunityId] = occurrence;
      }
    });

    return occurrencesMap;
  }, [allOccurrences]);

  const handleEditClick = (oportunity) => {
    setOperationType("edit");
    setOportunity(oportunity);
    setIsAdding(true);
  };

  const handleDeleteClick = (oportunity) => {
    setOperationType("delete");
    setOportunity(oportunity);
    setIsAdding(true);
  };

  const handleArchiveClick = (oportunity) => {
    setOperationType("archive");
    setOportunity(oportunity);
    setIsAdding(true);
  };

  const handleFilterChange = (filter, value) => {
    const newFilters = { ...filters, [filter]: value };
    setFilters(newFilters);

    let data = [...originalData];

    // Status
    if (newFilters.status !== "Todos") {
      data = data.filter((item) => item.status === newFilters.status);
    }

    // Modalidade
    if (newFilters.modalidade !== "Todos") {
      data = data.filter((item) => item.regime === newFilters.modalidade);
    }

    // Skill
    if (newFilters.skill !== "Todos") {
      data = data.filter((item) => item.skills.includes(newFilters.skill));
    }

    // VIGÊNCIAS
    if (newFilters.vigenciaStart || newFilters.vigenciaEnd) {
      data = data.filter((item) => {
        const field = item[newFilters.vigenciaField];

        if (newFilters.vigenciaField === "fim_vigencia" && field === null) {
          return true;
        }

        if (!field) return false;

        const date = new Date(field);

        if (
          newFilters.vigenciaStart &&
          date < new Date(newFilters.vigenciaStart)
        ) {
          return false;
        }

        if (newFilters.vigenciaEnd && date > new Date(newFilters.vigenciaEnd)) {
          return false;
        }

        return true;
      });
    }

    setFilteredData(data);
  };

  const handleApplicationFilterChange = (filter, value) => {
    let filtered = [...applications];
    const newFilters = { ...applicationFilters, [filter]: value };
    setApplicationFilters(newFilters);

    if (filter === "status" && value !== "Todos") {
      filtered = applications.filter(
        (item) => item.status === value && !item.canceled,
      );
    }

    setFilteredApplications(filtered);
  };

  const handleDownloadCurriculums = async () => {
    setIsDownloading(true);

    const professionalIds = filteredApplications
      .map((row) => row.professional._id)
      .filter(Boolean);

    if (!professionalIds.length) {
      return;
    }

    try {
      const response = await api.post(
        "/professional/download-curriculums",
        {
          professionalIds,
        },
        {
          responseType: "blob",
        },
      );
      const blob = new Blob([response.data], {
        type: "application/zip",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "curriculos.zip";
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Erro ao baixar currículos:", error);
    } finally {
      setIsDownloading(false);
    }
  };

  const handleViewProfessionalDocsClick = (prof) => {
    setSelectedProfessional(prof);
    setProfessionalDocsModalOpen(true);
  };

  const closeProfessionalDocsModal = () => {
    setSelectedProfessional(null);
    setProfessionalDocsModalOpen(false);
  };

  // const handleDownloadCurriculum = async (app) => {
  //   setIsDownloading(true);

  //   const professionalId = app.professional._id;

  //   if (!professionalId) {
  //     return;
  //   }

  //   try {
  //     const response = await api.post(
  //       "/professional/download-curriculums",
  //       {
  //         professionalIds: [professionalId],
  //       },
  //       {
  //         responseType: "blob",
  //       },
  //     );
  //     const blob = new Blob([response.data], {
  //       type: "application/zip",
  //     });
  //     const url = window.URL.createObjectURL(blob);
  //     const link = document.createElement("a");
  //     link.href = url;
  //     link.download = "curriculos.zip";
  //     document.body.appendChild(link);
  //     link.click();
  //     link.remove();
  //     window.URL.revokeObjectURL(url);
  //   } catch (error) {
  //     console.error("Erro ao baixar currículos:", error);
  //   } finally {
  //     setIsDownloading(false);
  //   }
  // };

  const getFilteredData = (data) => {
    const statusFilter =
      filters.status !== "Todos"
        ? data.filter((item) => item.status === filters.status)
        : [...data];
    const regimeFilter =
      filters.modalidade !== "Todos"
        ? statusFilter.filter((item) => item.regime === filters.modalidade)
        : [...statusFilter];
    const skillFilter =
      filters.skill !== "Todos"
        ? regimeFilter.filter((item) => item.skills.includes(filters.skill))
        : [...regimeFilter];

    return skillFilter;
  };

  const getAllOccurrences = async () => {
    try {
      const { data } = await api.get(`/professional_occurrence/list`);
      setAllOccurrences(data);
    } catch (err) {
      console.log(err);
      toast.error("Ocorreu um erro");
    }
  };

  const handleApplicationSelect = (applicationId) => {
    setSelectedApplications((prev) => {
      if (prev.includes(applicationId)) {
        return prev.filter((id) => id !== applicationId);
      }

      return [...prev, applicationId];
    });
  };

  const handleSendMessage = async () => {
    try {
      const { data } = await api.post("/user/get-emails", {
        userIds: selectedApplications.map((prof) => prof.professional.user),
      });

      const selectedEmails = data.emails;
      const to = encodeURIComponent(selectedEmails.join(";"));
      const subject = encodeURIComponent("Assunto");
      const body = encodeURIComponent("Mensagem");

      const outlookWebUrl = `https://outlook.office.com/mail/deeplink/compose?to=${to}&subject=${subject}&body=${body}`;

      window.open(outlookWebUrl, "_blank");

      await api.post("/professional_occurrence/bunk-create", {
        applications: selectedApplications.map((app) => ({
          professional: app.professional._id,
          oportunity: app._id,
        })),
      });
    } catch (err) {
      toast.error("Ocorreu um erro");
      console.error(err);
    }
  };

  const clearFilters = () => {
    setFilters({
      status: "Todos",
      modalidade: "Todos",
      skill: "Todos",
      vigenciaField: "inicio_vigencia",
      vigenciaStart: null,
      vigenciaEnd: null,
    });

    setFilteredData([...originalData]);
  };

  const countByStatus = (arr) => {
    return arr.reduce((acc, item) => {
      const status = item.status;

      if (!acc[status]) {
        acc[status] = 0;
      }

      acc[status]++;

      return acc;
    }, {});
  };

  const handleShowApplications = async (selectedOportunity) => {
    try {
      const res = await api.get(
        `/application/get-by-oportunity/${typeof selectedOportunity === "string" ? selectedOportunity : selectedOportunity._id}`,
      );
      setApplications(res.data);
      setFilteredApplications(res.data);
      setAppStatusCount(countByStatus(res.data));
      setIsShowingApplications(true);
      getAllOccurrences();
    } catch (err) {
      console.error(err);
      toast.error("Ocorreu um erro: ", err);
    }
  };

  const closeApplicationsView = () => {
    setSelectedApplications([]);
    setIsShowingApplications(false);
    setApplicationFilters({
      status: "Todos",
    });
    setApplications([]);
  };

  const handleApplicationStatusChange = async (app, newStatus) => {
    try {
      const res = await api.put("/application/update/" + app._id, {
        status: newStatus,
      });
      if (res.status === 200) {
        toast.success("Status atualizado!");
      }
      const res2 = await api.get(
        `/application/get-by-oportunity/${app.oportunity._id}`,
      );
      setApplications(res2.data);
      setFilteredApplications(res2.data);
      setAppStatusCount(countByStatus(res2.data));

      setStartAppIndex((currentApplicationPage - 1) * itemsPerApplicationsPage);
      setEndAppIndex(startAppIndex + itemsPerApplicationsPage);
      setPaginatedApplications(
        filteredApplications.slice(startAppIndex, endAppIndex),
      );
      setTotalAppPages(
        Math.ceil(filteredApplications.length / itemsPerApplicationsPage),
      );
    } catch (err) {
      toast.error("Ocorreu um erro: ", err);
      console.error(err);
    }
  };

  const handleOccurrencesModalClick = (app) => {
    setSelectedProfessional(app.professional);
    setApplication(app);
    setTriagemOccurrencesModalOpen(true);
  };

  const closeOccurrencesModal = () => {
    setSelectedProfessional(null);
    setApplication(null);
    setTriagemOccurrencesModalOpen(false);
  };

  const sortedAndFilteredData = useMemo(() => {
    return filteredData
      .filter((item) =>
        item.cargo
          ?.toLocaleUpperCase()
          .includes(searchValue.toLocaleUpperCase()),
      )
      .sort((a, b) => {
        if (sortType === "cargo") {
          const nameA = a.cargo?.toLocaleUpperCase() || "";
          const nameB = b.cargo?.toLocaleUpperCase() || "";
          if (nameA < nameB) return sortDirection ? -1 : 1;
          if (nameA > nameB) return sortDirection ? 1 : -1;
          return 0;
        } else if (sortType === "data") {
          const dateA = new Date(a.inicio_vigencia);
          const dateB = new Date(b.inicio_vigencia);
          return sortDirection ? dateA - dateB : dateB - dateA;
        }
        return 0;
      });
  }, [filteredData, searchValue, sortType, sortDirection]);

  // PAGINAÇÃO OPORTUNIDADES
  const startIndex = (currentOportunityPage - 1) * itemsPerOportunityPage;
  const endIndex = startIndex + itemsPerOportunityPage;
  const paginatedData = sortedAndFilteredData.slice(startIndex, endIndex);

  const totalPages = Math.ceil(
    sortedAndFilteredData.length / itemsPerOportunityPage,
  );

  useEffect(() => {
    getSkills();
  }, []);

  useEffect(() => {
    if (tableData) {
      setOriginalData(tableData);
      setFilteredData(tableData);
      setFilteredData(getFilteredData(tableData));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tableData]);

  useEffect(() => {
    setCurrentOportunityPage(1);
  }, [searchValue, sortType, sortDirection, filteredData]);

  useEffect(() => setCurrentApplicationPage(1), [itemsPerApplicationsPage]);

  useEffect(() => {
    const savedState = sessionStorage.getItem("adminPageState");

    if (!savedState) {
      setCurrentApplicationPage(1);
      return;
    }

    const state = JSON.parse(savedState);

    setCurrentApplicationPage(state.currentApplicationPage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [applications, filteredApplications]);

  useEffect(() => {
    if (isShowingApplications) {
      setStartAppIndex((currentApplicationPage - 1) * itemsPerApplicationsPage);
      setEndAppIndex(startAppIndex + itemsPerApplicationsPage);
      setPaginatedApplications(
        filteredApplications.slice(startAppIndex, endAppIndex),
      );
      setTotalAppPages(
        Math.ceil(filteredApplications.length / itemsPerApplicationsPage),
      );
    }
  }, [
    currentApplicationPage,
    endAppIndex,
    filteredApplications,
    isShowingApplications,
    startAppIndex,
    itemsPerApplicationsPage,
  ]);

  useEffect(() => {
    const savedState = sessionStorage.getItem("adminPageState");

    if (!savedState) return;

    const state = JSON.parse(savedState);

    if (state.selectedTable === "oportunity") {
      handleShowApplications(state.selectedOportunity);
      // handleApplicationFilterChange("status", state.applicationFiltersStatus);
    }

    setTimeout(() => {
      sessionStorage.removeItem("adminPageState");
    }, 2000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tableData]);

  useEffect(() => {
    const savedState = sessionStorage.getItem("adminPageState");

    if (!savedState || applications.length < 1) return;

    const state = JSON.parse(savedState);

    if (state.selectedTable === "oportunity") {
      handleApplicationFilterChange("status", state.applicationFiltersStatus);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [applications]);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
      <OportunityContainer>
        <LeftSection>
          {!isShowingApplications ? (
            <ToggleViewButton onClick={() => toggleView(!isAdding)}>
              <span>{isAdding ? "Voltar" : "Adicionar"}</span>
            </ToggleViewButton>
          ) : (
            <ToggleViewButton onClick={closeApplicationsView}>
              <span>Voltar</span>
            </ToggleViewButton>
          )}
          {!isShowingApplications ? (
            <FiltersSection>
              <InputContainer>
                <label for="status-filtro">Status:</label>
                <Select
                  id="status-filtro"
                  name="status-filtro"
                  value={filters.status}
                  sx={{
                    backgroundColor: "#FFF",
                    height: "50px",
                    textAlign: "start",
                    fontSize: "0.9rem",

                    "&.Mui-disabled": {
                      backgroundColor: "#f2f2f2",
                    },

                    "& .MuiSelect-select.Mui-disabled": {
                      backgroundColor: "#f2f2f2",
                    },
                  }}
                  onChange={(e) => handleFilterChange("status", e.target.value)}
                >
                  <MenuItem value={"Todos"}>{"Todos"}</MenuItem>
                  {STATUS_TYPES.map((item) => (
                    <MenuItem value={item}>{item}</MenuItem>
                  ))}
                </Select>
              </InputContainer>
              <InputContainer>
                <label for="regime-filtro">Regime:</label>
                <Select
                  id="regime-filtro"
                  name="regime-filtro"
                  value={filters.modalidade}
                  sx={{
                    backgroundColor: "#FFF",
                    height: "50px",
                    textAlign: "start",
                    fontSize: "0.9rem",

                    "&.Mui-disabled": {
                      backgroundColor: "#f2f2f2",
                    },

                    "& .MuiSelect-select.Mui-disabled": {
                      backgroundColor: "#f2f2f2",
                    },
                  }}
                  onChange={(e) =>
                    handleFilterChange("modalidade", e.target.value)
                  }
                >
                  <MenuItem value={"Todos"}>{"Todos"}</MenuItem>
                  {REGIMES.map((item) => (
                    <MenuItem value={item}>{item}</MenuItem>
                  ))}
                </Select>
              </InputContainer>
              <InputContainer>
                <label for="skill-filtro">Tecnologia:</label>
                <Select
                  id="skill-filtro"
                  name="skill-filtro"
                  value={filters.skill}
                  sx={{
                    backgroundColor: "#FFF",
                    height: "50px",
                    textAlign: "start",
                    fontSize: "0.9rem",

                    "&.Mui-disabled": {
                      backgroundColor: "#f2f2f2",
                    },

                    "& .MuiSelect-select.Mui-disabled": {
                      backgroundColor: "#f2f2f2",
                    },
                  }}
                  onChange={(e) => handleFilterChange("skill", e.target.value)}
                >
                  <MenuItem value={"Todos"}>{"Todos"}</MenuItem>
                  {skills.map((item) => (
                    <MenuItem value={item.name}>{item.name}</MenuItem>
                  ))}
                </Select>
              </InputContainer>
              <InputContainer>
                <label for="vigenciaField">Filtrar vigência por:</label>
                <Select
                  id="vigenciaField"
                  name="vigenciaField"
                  value={filters.vigenciaField}
                  sx={{
                    backgroundColor: "#FFF",
                    height: "50px",
                    textAlign: "start",
                    fontSize: "0.9rem",

                    "&.Mui-disabled": {
                      backgroundColor: "#f2f2f2",
                    },

                    "& .MuiSelect-select.Mui-disabled": {
                      backgroundColor: "#f2f2f2",
                    },
                  }}
                  onChange={(e) =>
                    handleFilterChange("vigenciaField", e.target.value)
                  }
                >
                  <MenuItem value="inicio_vigencia">
                    Início da vigência
                  </MenuItem>
                  <MenuItem value="fim_vigencia">Fim da vigência</MenuItem>
                </Select>
              </InputContainer>

              <InputContainer>
                <label>Data De:</label>
                <TextField
                  type="date"
                  value={filters.vigenciaStart ?? ""}
                  sx={{
                    backgroundColor: "#FFF",
                    textAlign: "start",
                    fontSize: "0.9rem",
                    borderRadius: "5px",
                  }}
                  onChange={(e) =>
                    handleFilterChange("vigenciaStart", e.target.value)
                  }
                />
              </InputContainer>

              <InputContainer>
                <label>Até:</label>
                <TextField
                  type="date"
                  value={filters.vigenciaEnd ?? ""}
                  sx={{
                    backgroundColor: "#FFF",
                    textAlign: "start",
                    fontSize: "0.9rem",
                    borderRadius: "5px",
                  }}
                  onChange={(e) =>
                    handleFilterChange("vigenciaEnd", e.target.value)
                  }
                />
              </InputContainer>
              <ToggleViewButton onClick={clearFilters}>
                <span>Limpar filtros</span>
              </ToggleViewButton>
            </FiltersSection>
          ) : (
            <>
              <FiltersSection>
                <InputContainer>
                  <label for="status-filtro-candidatura">Status:</label>
                  <Select
                    id="status-filtro-candidatura"
                    name="status-filtro-candidatura"
                    value={applicationFilters.status}
                    sx={{
                      backgroundColor: "#FFF",
                      height: "50px",
                      textAlign: "start",
                      fontSize: "0.9rem",

                      "&.Mui-disabled": {
                        backgroundColor: "#f2f2f2",
                      },

                      "& .MuiSelect-select.Mui-disabled": {
                        backgroundColor: "#f2f2f2",
                      },
                    }}
                    onChange={(e) =>
                      handleApplicationFilterChange("status", e.target.value)
                    }
                  >
                    <MenuItem value={"Todos"}>{"Todos"}</MenuItem>
                    {APPLICATION_STATUS_TYPES.map((item) => (
                      <MenuItem value={item}>{item}</MenuItem>
                    ))}
                  </Select>
                </InputContainer>
              </FiltersSection>
              <div style={{ marginTop: "20px", color: "white" }}>
                {Object.entries(appStatusCount).map(([campo, valor]) => (
                  <div key={campo}>
                    <span>
                      {campo}: {valor}
                    </span>
                  </div>
                ))}
              </div>
              <div style={{ marginTop: "15px" }}>
                <ToggleViewButton
                  disabled={isDownloading}
                  onClick={handleDownloadCurriculums}
                >
                  <span>{"Baixar currículos"}</span>
                </ToggleViewButton>
              </div>
              <div
                style={{
                  marginTop: "15px",
                  gap: "5px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <ToggleViewButton
                  disabled={selectedApplications < 1}
                  onClick={handleSendMessage}
                >
                  <span>{"Mandar mensagem"}</span>
                </ToggleViewButton>
                <span
                  style={{
                    color: "white",
                    fontSize: "0.7rem",
                  }}
                >{`Profissionais selecionados: ${selectedApplications.length}`}</span>
                {selectedApplications.length > 0 && (
                  <HighlightSpan onClick={() => setSelectedApplications([])}>
                    Limpar Seleção
                  </HighlightSpan>
                )}
              </div>
            </>
          )}
        </LeftSection>
        {isAdding ? (
          <AddingSection>
            <Form>
              <InputRow>
                <InputContainerCargo>
                  <label for="cargo">Cargo:</label>
                  <input
                    id="cargo"
                    name="cargo"
                    type="text"
                    defaultValue={oportunity.cargo}
                    value={oportunity.cargo}
                    disabled={
                      operationType === "delete" || operationType === "archive"
                    }
                    onChange={(e) => {
                      setOportunity({ ...oportunity, cargo: e.target.value });
                    }}
                    onBlur={(e) =>
                      !e.target.value
                        ? setOportunity({
                            ...oportunity,
                            cargo: oportunity.cargo,
                          })
                        : setOportunity({
                            ...oportunity,
                            cargo: e.target.value,
                          })
                    }
                  />
                </InputContainerCargo>
                <InputContainerDate>
                  <label for="inicio_vigencia">Início da Vigência:</label>
                  <DatePicker
                    id="inicio_vigencia"
                    disabled={
                      operationType === "delete" || operationType === "archive"
                    }
                    value={
                      oportunity.inicio_vigencia
                        ? dayjs(oportunity.inicio_vigencia)
                        : null
                    }
                    onChange={(newValue) => {
                      setOportunity({
                        ...oportunity,
                        inicio_vigencia: newValue,
                      });
                    }}
                  />
                </InputContainerDate>
                <InputContainerDate>
                  <label for="fim_vigencia">Fim da Vigência:</label>
                  <DatePicker
                    id="fim_vigencia"
                    disabled={
                      operationType === "delete" || operationType === "archive"
                    }
                    value={
                      oportunity.fim_vigencia
                        ? dayjs(oportunity.fim_vigencia)
                        : null
                    }
                    onChange={(newValue) => {
                      setOportunity({
                        ...oportunity,
                        fim_vigencia: newValue,
                      });
                    }}
                  />
                </InputContainerDate>
              </InputRow>
              <InputRow>
                <InputContainerHalf>
                  <label for="empresa">Empresa:</label>
                  <input
                    id="empresa"
                    name="empresa"
                    type="text"
                    defaultValue={oportunity.empresa}
                    value={oportunity.empresa}
                    disabled={
                      operationType === "delete" || operationType === "archive"
                    }
                    onChange={(e) => {
                      setOportunity({ ...oportunity, empresa: e.target.value });
                    }}
                    onBlur={(e) =>
                      !e.target.value
                        ? setOportunity({
                            ...oportunity,
                            empresa: oportunity.empresa,
                          })
                        : setOportunity({
                            ...oportunity,
                            empresa: e.target.value,
                          })
                    }
                  />
                </InputContainerHalf>
                <InputContainerHalf>
                  <label for="local">Local:</label>
                  <input
                    id="local"
                    name="local"
                    type="text"
                    defaultValue={oportunity.local}
                    value={oportunity.local}
                    disabled={
                      operationType === "delete" || operationType === "archive"
                    }
                    onChange={(e) => {
                      setOportunity({ ...oportunity, local: e.target.value });
                    }}
                    onBlur={(e) =>
                      !e.target.value
                        ? setOportunity({
                            ...oportunity,
                            local: oportunity.local,
                          })
                        : setOportunity({
                            ...oportunity,
                            local: e.target.value,
                          })
                    }
                  />
                </InputContainerHalf>
              </InputRow>
              <InputRow>
                <InputContainer>
                  <label for="remuneracao">Remuneração:</label>
                  <NumericFormat
                    id="remuneracao"
                    name="remuneracao"
                    value={oportunity.remuneracao}
                    disabled={
                      operationType === "delete" || operationType === "archive"
                    }
                    thousandSeparator="."
                    decimalSeparator=","
                    decimalScale={2}
                    fixedDecimalScale
                    allowNegative={false}
                    prefix="R$ "
                    onValueChange={(values) =>
                      setOportunity({
                        ...oportunity,
                        remuneracao: values.value,
                      })
                    }
                    placeholder="0,00"
                  />
                </InputContainer>
                <InputContainer>
                  <label for="regime">Regime:</label>
                  <Select
                    id="regime"
                    name="regime"
                    value={oportunity.regime}
                    disabled={
                      operationType === "delete" || operationType === "archive"
                    }
                    sx={{
                      backgroundColor: "#FFF",
                      height: "50px",
                      textAlign: "start",
                      fontSize: "0.9rem",

                      "&.Mui-disabled": {
                        backgroundColor: "#f2f2f2",
                      },

                      "& .MuiSelect-select.Mui-disabled": {
                        backgroundColor: "#f2f2f2",
                      },
                    }}
                    onChange={(e) =>
                      setOportunity({ ...oportunity, regime: e.target.value })
                    }
                  >
                    {REGIMES.map((item) => (
                      <MenuItem value={item}>{item}</MenuItem>
                    ))}
                  </Select>
                </InputContainer>
                <InputContainer>
                  <label for="vinculo">Vínculo:</label>
                  <input
                    id="vinculo"
                    name="vinculo"
                    type="text"
                    defaultValue={oportunity.vinculo}
                    value={oportunity.vinculo}
                    disabled={
                      operationType === "delete" || operationType === "archive"
                    }
                    onChange={(e) => {
                      setOportunity({ ...oportunity, vinculo: e.target.value });
                    }}
                    onBlur={(e) =>
                      !e.target.value
                        ? setOportunity({
                            ...oportunity,
                            vinculo: oportunity.vinculo,
                          })
                        : setOportunity({
                            ...oportunity,
                            vinculo: e.target.value,
                          })
                    }
                  />
                </InputContainer>
                {operationType !== "create" ? (
                  <InputContainer>
                    <label for="status">Status:</label>
                    <Select
                      id="status"
                      name="status"
                      value={oportunity.status}
                      disabled={
                        operationType === "delete" ||
                        operationType === "archive"
                      }
                      sx={{
                        backgroundColor: "#FFF",
                        height: "50px",
                        textAlign: "start",
                        fontSize: "0.9rem",

                        "&.Mui-disabled": {
                          backgroundColor: "#f2f2f2",
                        },

                        "& .MuiSelect-select.Mui-disabled": {
                          backgroundColor: "#f2f2f2",
                        },
                      }}
                      onChange={(e) =>
                        setOportunity({ ...oportunity, status: e.target.value })
                      }
                    >
                      {STATUS_TYPES.map((item) => (
                        <MenuItem value={item}>{item}</MenuItem>
                      ))}
                    </Select>
                  </InputContainer>
                ) : (
                  <></>
                )}
              </InputRow>
              <InputRow>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                    height: "fit-content",
                  }}
                >
                  <label>Descrição:</label>
                  <ReactQuill
                    id="descricao"
                    theme="snow"
                    value={oportunity.descricao}
                    readOnly={
                      operationType === "delete" || operationType === "archive"
                    }
                    onChange={(value) =>
                      setOportunity({ ...oportunity, descricao: value })
                    }
                  />
                </div>
              </InputRow>
              <InputRow>
                <div>
                  <div style={{ marginBottom: "10px" }}>
                    <span
                      style={{
                        fontSize: "0.9rem",
                        color: "#104467",
                        alignSelf: "flex-start",
                        textAlign: "left",
                      }}
                    >
                      Habilidades:
                    </span>
                  </div>
                  <Checkboxes
                    options={skills}
                    data={oportunity}
                    setData={setOportunity}
                    op={true}
                  />
                </div>
              </InputRow>
              <InputRowSubmit>
                {operationType === "delete" ? (
                  <span>Você confirma a remoção dessa oportunidade?</span>
                ) : operationType === "archive" ? (
                  <span>Você confirma o arquivo dessa oportunidade?</span>
                ) : (
                  <WarningInputMessage>{error}</WarningInputMessage>
                )}
                <SubmitButton
                  disabled={isSubmitting}
                  onClick={
                    operationType === "create"
                      ? handleSubmit
                      : operationType === "edit"
                        ? handleEditSave
                        : operationType === "delete"
                          ? handleDelete
                          : handleArchive
                  }
                >
                  <span>Enviar</span>
                </SubmitButton>
              </InputRowSubmit>
            </Form>
          </AddingSection>
        ) : isShowingApplications ? (
          <div
            style={{
              width: "100%",
              height: "100%",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "5px",
                flex: 1,
                minWidth: "300px",
                padding: "20px",
                backgroundColor: "white",
                overflow: "auto",
              }}
            >
              {paginatedApplications.map((application) => (
                <div
                  key={application._id}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                    border: "1px solid #104467",
                    borderRadius: "5px",
                    padding: "15px",
                    color: "#104467",
                    gap: "15px",
                  }}
                >
                  <Checkbox
                    checked={selectedApplications.includes(application)}
                    onChange={() => handleApplicationSelect(application)}
                    sx={{
                      color: "#104467",
                      "&.Mui-checked": {
                        color: "#104467",
                      },
                    }}
                  />
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "100%",
                    }}
                  >
                    <div>
                      <div
                        style={{
                          color: "#104467",
                        }}
                        onClick={() => handleViewProfessional(application)}
                      >
                        <span
                          style={{
                            fontSize: "1.1rem",
                            fontWeight: "600",
                            cursor: "pointer",
                          }}
                        >{`${application.professional?.name}${
                          application.professional?.cpf
                            ? " (" + application.professional?.cpf + ")"
                            : ""
                        }`}</span>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          marginTop: "10px",
                        }}
                      >
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <span>{`Status: ${
                            application.canceled
                              ? "CANCELADA"
                              : application.status
                          }`}</span>
                        </div>
                        <span>{`Data da candidatura: ${dayjs(
                          application.date,
                        ).format("DD/MM/YYYY")}`}</span>
                        <span>{`Última ocorrência: ${lastOccurrencesByOportunity[application._id] ? lastOccurrencesByOportunity[application._id].title + " (" + dayjs(lastOccurrencesByOportunity[application._id].date).format("DD/MM/YYYY") + ")" : "Sem ações"}`}</span>
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "20px",
                      }}
                    >
                      <Select
                        id="status-candidatura"
                        name="status-candidatura"
                        value={application.status}
                        disabled={application.canceled}
                        sx={{
                          backgroundColor: "#FFF",
                          height: "50px",
                          textAlign: "start",
                          fontSize: "0.9rem",

                          "&.Mui-disabled": {
                            backgroundColor: "#f2f2f2",
                          },

                          "& .MuiSelect-select.Mui-disabled": {
                            backgroundColor: "#f2f2f2",
                          },
                        }}
                        onChange={(e) =>
                          handleApplicationStatusChange(
                            application,
                            e.target.value,
                          )
                        }
                      >
                        {APPLICATION_STATUS_TYPES.map((item) => (
                          <MenuItem value={item}>{item}</MenuItem>
                        ))}
                      </Select>
                      <Tooltip arrow title={"Ver Documentos do Profissional"}>
                        <IconButton
                          onClick={() =>
                            handleViewProfessionalDocsClick(
                              application.professional,
                            )
                          }
                        >
                          <Article />
                        </IconButton>
                      </Tooltip>
                      <Tooltip arrow title={"Abrir notas"}>
                        <IconButton
                          onClick={() =>
                            handleOccurrencesModalClick(application)
                          }
                        >
                          <ModeCommentIcon />
                        </IconButton>
                      </Tooltip>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div
              style={{
                height: "70px",
                display: "flex",
                flexDirection: "column",
                alignItems: "end",
                justifyContent: "center",
                background: "white",
                gap: "3px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginRight: "10px",
                }}
              >
                <div
                  style={{
                    marginRight: "10px",
                    display: "flex",
                    gap: "10px",
                    alignItems: "center",
                  }}
                >
                  <span style={{ fontSize: "0.85rem" }}>Linhas por página</span>
                  <Select
                    id="lines-per-page"
                    name="lines-per-page"
                    value={itemsPerApplicationsPage}
                    sx={{
                      backgroundColor: "#FFF",
                      height: "30px",
                      textAlign: "start",
                      fontSize: "0.9rem",
                    }}
                    onChange={(e) =>
                      setItemsPerApplicationsPage(e.target.value)
                    }
                  >
                    <MenuItem value={5}>5</MenuItem>
                    <MenuItem value={10}>10</MenuItem>
                    <MenuItem value={15}>15</MenuItem>
                    <MenuItem value={20}>20</MenuItem>
                    <MenuItem value={25}>25</MenuItem>
                    <MenuItem value={30}>30</MenuItem>
                    <MenuItem value={50}>50</MenuItem>
                    <MenuItem value={100}>100</MenuItem>
                  </Select>
                </div>

                <span
                  style={{ fontSize: "0.85rem", marginRight: "10px" }}
                >{`${itemsPerApplicationsPage * currentApplicationPage - (itemsPerApplicationsPage - 1)}-${Math.min(itemsPerApplicationsPage * currentApplicationPage, applications.length)} de ${applications.length}`}</span>

                <Tooltip
                  arrow
                  disabled={currentApplicationPage === 1}
                  placement="bottom"
                  title={"Primeira página"}
                  onClick={() => setCurrentApplicationPage(1)}
                >
                  <IconButton>
                    <FirstPageIcon style={{ fontSize: "20px" }} />
                  </IconButton>
                </Tooltip>
                <Tooltip
                  arrow
                  disabled={currentApplicationPage === 1}
                  placement="bottom"
                  title={"Página anterior"}
                  onClick={() =>
                    setCurrentApplicationPage((p) => Math.max(p - 1, 1))
                  }
                >
                  <IconButton>
                    <ChevronLeftIcon style={{ fontSize: "20px" }} />
                  </IconButton>
                </Tooltip>
                <Tooltip
                  arrow
                  disabled={currentApplicationPage === totalAppPages}
                  placement="bottom"
                  title={"Próxima página"}
                  onClick={() =>
                    setCurrentApplicationPage((p) =>
                      Math.min(p + 1, totalAppPages),
                    )
                  }
                >
                  <IconButton>
                    <ChevronRightIcon style={{ fontSize: "20px" }} />
                  </IconButton>
                </Tooltip>
                <Tooltip
                  arrow
                  disabled={currentApplicationPage === totalAppPages}
                  placement="bottom"
                  title={"Última página"}
                  onClick={() => setCurrentApplicationPage(totalAppPages)}
                >
                  <IconButton>
                    <LastPageIcon style={{ fontSize: "20px" }} />
                  </IconButton>
                </Tooltip>
              </div>
            </div>
          </div>
        ) : (
          <div
            style={{ display: "flex", flexDirection: "column", width: "100%" }}
          >
            <div
              style={{
                display: "flex",
                backgroundColor: "#ddd",
              }}
            >
              <div
                style={{
                  width: "80%",
                  padding: "10px",
                }}
              >
                <TextField
                  value={searchValue}
                  style={{ width: "100%" }}
                  onChange={(e) => setSearchValue(e.target.value)}
                />
              </div>
              <div
                style={{
                  flex: 1,
                  display: "flex",
                  padding: "10px 0",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <Tooltip
                  arrow
                  placement="bottom"
                  title={sortDirection ? "Crescente" : "Decrescente"}
                  onClick={() => setSortDirection(!sortDirection)}
                >
                  <IconButton>
                    <SwapVertIcon style={{ fontSize: "35px" }} />
                  </IconButton>
                </Tooltip>
                <Tooltip
                  arrow
                  placement="bottom"
                  title="Por cargo"
                  onClick={() => setSortType("cargo")}
                  style={{
                    backgroundColor: sortType === "cargo" ? "#eee" : "unset",
                  }}
                >
                  <IconButton>
                    <AbcIcon style={{ fontSize: "35px" }} />
                  </IconButton>
                </Tooltip>
                <Tooltip
                  arrow
                  placement="bottom"
                  title="Por data"
                  onClick={() => setSortType("data")}
                  style={{
                    backgroundColor: sortType === "data" ? "#eee" : "unset",
                  }}
                >
                  <IconButton>
                    <CalendarMonthIcon style={{ fontSize: "35px" }} />
                  </IconButton>
                </Tooltip>
              </div>
            </div>
            <CardsSection>
              {paginatedData.map((item) => (
                <OportunityCard>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      gap: "15px",
                    }}
                  >
                    <h2 style={{ color: "#104467", fontSize: "1rem" }}>
                      {item.cargo}
                    </h2>
                    <div style={{ display: "flex", gap: "2px" }}>
                      {item.status !== "arquivada" ? (
                        <IconContainer onClick={() => handleArchiveClick(item)}>
                          {/* FAZER COM QUE SE ELA JÁ ESTIVER ARQUIVADA, PASSAR PARA INATIVA OU ATIVA COM BASE NAS DATAS */}
                          <ArchiveIcon sx={{ fontSize: "20px" }} />
                        </IconContainer>
                      ) : (
                        <></>
                      )}
                      <IconContainer onClick={() => handleDeleteClick(item)}>
                        <DeleteIcon sx={{ fontSize: "20px" }} />
                      </IconContainer>
                      <IconContainer onClick={() => handleEditClick(item)}>
                        <EditIcon sx={{ fontSize: "20px" }} />
                      </IconContainer>
                    </div>
                  </div>
                  <div style={{ margin: "5px 0" }}>
                    <span style={{ fontSize: "0.8rem" }}>
                      {`${dayjs(item.inicio_vigencia).format("DD/MM/YYYY")} - ${
                        item.fim_vigencia
                          ? dayjs(item.fim_vigencia).format("DD/MM/YYYY")
                          : "Indefinido"
                      }`}
                    </span>
                  </div>
                  <div
                    style={{
                      width: "100%",
                      maxHeight: "75px",
                      textAlign: "justify",
                      fontSize: "0.9rem",
                      overflowY: "auto",
                      textOverflow: "ellipsis",
                      wordBreak: "break-word",
                      overflowWrap: "break-word",
                    }}
                  >
                    <span>{`Oportunidade na empresa ${item.empresa}`}</span>
                  </div>
                  <div
                    onClick={() => openModal(item)}
                    style={{
                      marginTop: "20px",
                      backgroundColor: "#104467",
                      height: "35px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "0.8rem",
                      color: "white",
                      cursor: "pointer",
                      borderRadius: "5px",
                    }}
                  >
                    Ver Detalhes
                  </div>
                  <div
                    onClick={() => handleShowApplications(item)}
                    style={{
                      marginTop: "5px",
                      backgroundColor: "white",
                      height: "35px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "0.8rem",
                      color: "#104467",
                      border: "1px solid #104467",
                      cursor: "pointer",
                      borderRadius: "5px",
                    }}
                  >
                    Ver Candidaturas
                  </div>
                  <div
                    style={{
                      marginTop: "5px",
                      textAlign: "center",
                      fontSize: "0.8rem",
                    }}
                  >
                    <span>{`Total de candidaturas: ${item.applications}`}</span>
                  </div>
                </OportunityCard>
              ))}
            </CardsSection>
            <div
              style={{
                height: "70px",
                display: "flex",
                flexDirection: "column",
                alignItems: "end",
                justifyContent: "center",
                background: "white",
                gap: "3px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginRight: "10px",
                }}
              >
                <div
                  style={{
                    marginRight: "10px",
                    display: "flex",
                    gap: "10px",
                    alignItems: "center",
                  }}
                >
                  <span style={{ fontSize: "0.85rem" }}>Linhas por página</span>
                  <Select
                    id="lines-per-page"
                    name="lines-per-page"
                    value={itemsPerOportunityPage}
                    sx={{
                      backgroundColor: "#FFF",
                      height: "30px",
                      textAlign: "start",
                      fontSize: "0.9rem",
                    }}
                    onChange={(e) => setItemsPerOportunityPage(e.target.value)}
                  >
                    <MenuItem value={5}>5</MenuItem>
                    <MenuItem value={10}>10</MenuItem>
                    <MenuItem value={15}>15</MenuItem>
                    <MenuItem value={20}>20</MenuItem>
                    <MenuItem value={25}>25</MenuItem>
                    <MenuItem value={30}>30</MenuItem>
                    <MenuItem value={50}>50</MenuItem>
                    <MenuItem value={100}>100</MenuItem>
                  </Select>
                </div>

                <span
                  style={{ fontSize: "0.85rem", marginRight: "10px" }}
                >{`${itemsPerOportunityPage * currentOportunityPage - (itemsPerOportunityPage - 1)}-${Math.min(itemsPerOportunityPage * currentOportunityPage, tableData.length)} de ${tableData.length}`}</span>

                <Tooltip
                  arrow
                  disabled={itemsPerOportunityPage === 1}
                  placement="bottom"
                  title={"Primeira página"}
                  onClick={() => setCurrentOportunityPage(1)}
                >
                  <IconButton>
                    <FirstPageIcon style={{ fontSize: "20px" }} />
                  </IconButton>
                </Tooltip>
                <Tooltip
                  arrow
                  disabled={currentOportunityPage === 1}
                  placement="bottom"
                  title={"Página anterior"}
                  onClick={() =>
                    setCurrentOportunityPage((p) => Math.max(p - 1, 1))
                  }
                >
                  <IconButton>
                    <ChevronLeftIcon style={{ fontSize: "20px" }} />
                  </IconButton>
                </Tooltip>
                <Tooltip
                  arrow
                  disabled={currentOportunityPage === totalPages}
                  placement="bottom"
                  title={"Próxima página"}
                  onClick={() =>
                    setCurrentOportunityPage((p) => Math.min(p + 1, totalPages))
                  }
                >
                  <IconButton>
                    <ChevronRightIcon style={{ fontSize: "20px" }} />
                  </IconButton>
                </Tooltip>
                <Tooltip
                  arrow
                  disabled={currentOportunityPage === totalPages}
                  placement="bottom"
                  title={"Última página"}
                  onClick={() => setCurrentOportunityPage(totalPages)}
                >
                  <IconButton>
                    <LastPageIcon style={{ fontSize: "20px" }} />
                  </IconButton>
                </Tooltip>
              </div>
            </div>
          </div>
        )}
        <CreateNewOportunityModal
          open={modalOpen}
          onClose={closeModal}
          oportunity={oportunity}
        />
        <ProfessionalDocsModal
          open={professionalDocsModalOpen}
          onClose={closeProfessionalDocsModal}
          professional={selectedProfessional}
        />
        <TriagemOccurencesModal
          open={triagemOccurrencesModalOpen}
          onClose={closeOccurrencesModal}
          professional={selectedProfessional}
          oportunity={application}
          getAllOccurrences={getAllOccurrences}
        />
      </OportunityContainer>
    </LocalizationProvider>
  );
};
